import React from "react";
import "./Services.css";
import { BiCheck } from "react-icons/bi";
import { motion } from "framer-motion";
import { serviceCard } from "../../animations";

const ServiceCard = ({ title, items }) => {
  return (
    <motion.article className="service" variants={serviceCard}>
      <div className="service__head">
        <h3>{title}</h3>
      </div>

      <ul className="service__list">
        {items.map((item, index) => (
          <li key={index}>
            <BiCheck className="service__list-icon" size={16} />
            <p>{item}</p>
          </li>
        ))}
      </ul>
    </motion.article>
  );
};

export default ServiceCard;
